// extracted by mini-css-extract-plugin
module.exports = {"card":"commenti-card-module--card--3k4bp","active":"commenti-card-module--active--1avTr"};